/* eslint-disable @typescript-eslint/ban-types */
import React, { memo, useCallback, useEffect, useMemo, useState, } from 'react';
import { CustomButtonGroup, CustomTextArea, SelectDropDown, useAppDispatch, useAppSelector, useEffectOnce, } from '../../../globalUtils/globalExports';
import { fetchRuleEngineRaiseATicketCategories, fetchRuleEngineRaiseATicketUrgency, getReferenceDataReducer } from '../../../rmsReduxStore/reduxExports';
import { cloneDeep, isEqual } from 'lodash';
import  {ExecutionPlan, RaiseTicketAction } from './ExecutionPlan';
import { fetchRuleEngineRaiseATicketCallType } from '../../../rmsReduxStore/referenceDataRedux/referenceDataCreators';
import './RaiseATicketSidePopover.css';

interface RaiseATicketSidePopoverProps{
    handleClose : Function;
    raiseATicketCallTypeValue : string;
    raiseATicket: RaiseTicketAction | null;
    executionPlan: ExecutionPlan;
    handleUpdateExecutionPlan: Function;
    ifOrElse: string,
    nodeId:string,
    parentNodeId: string
}

const RaiseATicketSidePopover = memo(function RaiseATicketSidePopover({
    handleClose,
    executionPlan,
    raiseATicket,
    handleUpdateExecutionPlan,
    ifOrElse,
    nodeId,
    parentNodeId,
    
} : RaiseATicketSidePopoverProps){

    const dispatch = useAppDispatch(); 
    const {ruleEngineRaiseATicketCategoryReferenceData,ruleEngineRaiseATicketUrgencyReferenceData} = useAppSelector(getReferenceDataReducer);
    const [formData,setFormData] = useState<RaiseTicketAction>({
        type: 'Raise Ticket',
        nodeId,
        description: '',
        callType: '',
        category: '',
        subCategory: '',
        urgency: '',
    })

    const [initialFormData,setInitialFormData] = useState<RaiseTicketAction>({
        type: 'Raise Ticket',
        nodeId,
        description: '',
        callType: '',
        category: '',
        subCategory: '',
        urgency: '',    
    });
    const [descriptionError,setDescriptionError] = useState<string|null>(null);


    useEffectOnce(()=>{
        dispatch(fetchRuleEngineRaiseATicketCategories());
        dispatch(fetchRuleEngineRaiseATicketUrgency());
        dispatch(fetchRuleEngineRaiseATicketCallType());
    })


    useEffect(()=>{
        if(raiseATicket){
            setInitialFormData(raiseATicket);
            setFormData(raiseATicket);
        } 
    },[raiseATicket])


    const disableButton = useCallback(() => {
        if(isEqual(initialFormData,formData))
            return true;
        return !(formData && formData?.callType && formData?.callType.length>0 && formData.category && formData.category.length>0 &&  formData.subCategory && formData?.subCategory.length>0 && formData.urgency && formData.urgency.length>0 &&  descriptionError === null) 
    }, [formData,descriptionError])


    const btnsList = useMemo(() => {
        return [
          {
            buttonText: 'Save',
            buttonId: 'add',
            btnClassName:  disableButton() ? 'primary__btn disabled' : 'primary__btn',
            handleClick: (): void => {
                const data = cloneDeep(formData);
                const formattedData : RaiseTicketAction = {
                    type: 'Raise Ticket',
                    nodeId,
                    description: data.description,
                    category: data.category,
                    subCategory: data.subCategory,
                    urgency: data.urgency,
                    callType: data.callType,
                }

                const executionData = cloneDeep(executionPlan);
                const actionIdx = executionData?.actions?.findIndex((executionDataItem) => executionDataItem.flowType === ifOrElse && executionDataItem?.parentNodeId === parentNodeId);
                const actionItemIndex = executionData?.actions?.[actionIdx]?.list?.findIndex(item => item?.type === 'Raise Ticket');
                if(actionItemIndex === -1){
                    executionData?.actions?.[actionIdx]?.list?.push(formattedData)
                }else{
                    executionData.actions[actionIdx].list[actionItemIndex] = formattedData
                }
                handleUpdateExecutionPlan(executionData);
                handleClose();
            },
            isDisabled: disableButton(),
            buttonVariant: 'filled',
          },
          {
            buttonText: 'Cancel',
            buttonId: 'cancel',
            btnClassName: 'secondary__btn',
            handleClick: (): void => {
                handleClose()
            },
            isDisabled: false,
            buttonVariant: 'outlined',
          },
        ];
      }, [formData,disableButton]);
      
    return(
        <>
         <div className='advance__rule__engine__raise__a__ticket__side__popover__wrapper'>
            <div className='advance__rule__engine__call__type__wrapper'>
                <div className='advance__rule__engine__raise__a__ticket__side__popover__row__label'>
                    Call Type *
                </div>
                <SelectDropDown
                    selectDropDownId={'advance__rule__engine__raise__a__ticket__call__type__dropdown'} 
                    handleSelectOptionChange={(val)=>{
                    const data = cloneDeep(formData);
                    setFormData({
                        ...data,
                        callType: val?.label ,
                        category: '',
                        subCategory: ''
                    })
                    }} 
                selectOptions={ruleEngineRaiseATicketCategoryReferenceData ?? []}
                selectValue={{id: formData?.callType, label: formData?.callType}}
                />
            </div>
            <div className='advance__rule__engine__category__wrapper'>
                <div className='advance__rule__engine__raise__a__ticket__side__popover__row__label'>
                    Category*
                </div>
                <SelectDropDown 
                    selectDropDownId={'advance__rule__engine__raise__a__ticket__popover__category__dropdown'} 
                    handleSelectOptionChange={(val)=>{
                        
                        const data = cloneDeep(formData);
                        setFormData({
                            ...data,
                            category: val?.label,
                            subCategory: ''
                        })
                        
                    }} 
                    selectOptions={ruleEngineRaiseATicketCategoryReferenceData?.find((item) => item?.label === formData?.callType)?.categories ?? []}
                    selectValue={{id : formData?.category, label : formData?.category,}}
                />
            </div>
            <div className='advance__rule__engine__sub__category__wrapper'>
                <div className='advance__rule__engine__raise__a__ticket__side__popover__row__label'>
                    Sub-Category*
                </div>
                <SelectDropDown
                    selectDropDownId={'advance__rule__engine__raise__a_ticket__popover__sub_category__dropdown'} 
                    handleSelectOptionChange={(val)=>{
                        const data = cloneDeep(formData);
                        setFormData({
                            ...data,
                            subCategory: val?.label
                        })
                    }} 
                    selectOptions={ruleEngineRaiseATicketCategoryReferenceData?.find((item) =>  item?.label === formData?.callType)?.categories?.find((item) => item?.label === formData?.category)?.subCategories ?? []}
                    selectValue={{id: formData?.subCategory, label : formData?.subCategory}}
                    />
            </div>
            <div className='advance__rule__engine__urgency__wrapper'>
                <div className='advance__rule__engine__raise__a__ticket__side__popover__row__label'>
                    Urgency*
                </div>
                <SelectDropDown 
                    selectDropDownId={'advance__rule__engine__raise__a__ticket__side__popover__urgency__dropdown'} 
                    handleSelectOptionChange={(val)=>{
                        const data = cloneDeep(formData);
                        setFormData({
                            ...data,
                            urgency: val?.label
                        })
                    }} 
                    selectOptions={ruleEngineRaiseATicketUrgencyReferenceData ?? []}
                    selectValue={{id: formData?.urgency, label: formData?.urgency}}
                />
            </div>
            <div className='advance__rule__engine__description__wrapper'>
                <div className='advance__rule__engine__raise__a__ticket__side__popover__row__label'>
                    Description
                </div>
                <CustomTextArea
                    inputValue={formData?.description} 
                    inputFieldId={'rule__engine__raise__a__ticket__description'}
                    isRequired={false}
                    isResizeable={true}
                    handleInputChange={(event)=>{
                        const data = cloneDeep(formData);
                        if(event?.target?.value.length > 500){
                            setDescriptionError('Max length is 500 characters');
                        }else {
                            setFormData({
                                ...data,
                                description: event?.target?.value
                            })
                            setDescriptionError(null);
                        }
                    }}
                    errorMessage={descriptionError}
                    />

            </div>
         </div>
         <div className='advance__rule__engine__side__popover-footer'>
          <CustomButtonGroup
            buttonsList={btnsList}
            buttonGroupClassName='button__group__footer' />
        </div>
        </>
    )
})

export default RaiseATicketSidePopover;